export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10347.33f47b91.jpg";